import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import TopTile from "../../components/HRMS/Dashboard/TopTile";
import Chart from "react-apexcharts";
import { ToastContainer, toast } from "react-toastify";

const AssetDashboard = () => {
  const [loading, setLoading] = useState(true);

  const [summary, setSummary] = useState({
    total_assets: 0,
    active_assets: 0,
    inactive_assets: 0,
    medical_assets: 0,
  });

  const [categoryChart, setCategoryChart] = useState({ labels: [], series: [] });
  const [licenseChart, setLicenseChart] = useState({ labels: [], series: [] });
  const [deptChart, setDeptChart] = useState({ labels: [], series: [] });

  const loadSummary = async () => {
    try {
      const { data } = await axios.get(`${API_BASE_URL}/asset/summary`);
      setSummary(data);
    } catch (err) {
      toast.error("Summary API failed");
      console.error(err);
    }
  };

  const loadCharts = async () => {
    try {
      const { data } = await axios.get(`${API_BASE_URL}/asset/chart-data`);

      setCategoryChart({
        labels: data.category_split.map((x) => x.label),
        series: data.category_split.map((x) => x.value),
      });

      setLicenseChart({
        labels: data.license_split.map((x) => x.label),
        series: data.license_split.map((x) => x.value),
      });

      setDeptChart({
        labels: data.dept_value_split.map((x) => x.label),
        series: data.dept_value_split.map((x) => x.value),
      });
    } catch (err) {
      toast.error("Chart API failed");
      console.error(err);
    }
  };

  useEffect(() => {
    (async () => {
      await Promise.all([loadSummary(), loadCharts()]);
      setLoading(false);
    })();
  }, []);

  const fmt = (n) => (n ?? 0).toLocaleString();

  const donutOptions = (labels) => ({
    labels,
    legend: { position: "bottom" },
    colors: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50", "#9C27B0"],
  });

  const barOptions = (labels) => ({
    chart: { type: "bar" },
    xaxis: { categories: labels },
    colors: ["#36A2EB"],
  });

  return (
    <>
      <ToastContainer />
      <div className="section-body mt-3">
        <div className="container-fluid">

          <div className="row g-3 mb-3">
            <TopTile label="Total Assets" iconClass="icon-layers" value={fmt(summary.total_assets)} loading={loading} />
            <TopTile label="Active Assets" iconClass="icon-check" value={fmt(summary.active_assets)} loading={loading} />
            <TopTile label="Inactive Assets" iconClass="icon-close" value={fmt(summary.inactive_assets)} loading={loading} />
            <TopTile label="Medical Assets" iconClass="icon-heart" value={fmt(summary.medical_assets)} loading={loading} />
          </div>

          <div className="row">
            <div className="col-lg-6 mb-3">
              <div className="card">
                <div className="card-header"><b>Category Split</b></div>
                <div className="card-body">
                  <Chart
                    options={donutOptions(categoryChart.labels)}
                    series={categoryChart.series}
                    type="donut"
                    height={300}
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-6 mb-3">
              <div className="card">
                <div className="card-header"><b>Licensed vs Non Licensed</b></div>
                <div className="card-body">
                  <Chart
                    options={donutOptions(licenseChart.labels)}
                    series={licenseChart.series}
                    type="donut"
                    height={300}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 mb-3">
              <div className="card">
                <div className="card-header"><b>Department Wise Asset Value</b></div>
                <div className="card-body">
                  <Chart
                    options={barOptions(deptChart.labels)}
                    series={[{ name: "Value", data: deptChart.series }]}
                    type="bar"
                    height={320}
                  />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default AssetDashboard;
